import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getMyChargers } from '../../store/actions/charging-actions';
import { notificationService } from '../../services/notification-service';
import { isSuccessful } from '../../services/api-requests';
import { NavigationProp, useNavigation } from '@react-navigation/native';

interface Props {
  verified: any;
  onVerified: () => void;
  returnToOnboarding?: boolean;
}

const StripeSubscriptionHandler: React.FC<Props> = ({ verified, onVerified, returnToOnboarding }) => {
  const dispatch = useDispatch();
  const navigation = useNavigation<NavigationProp<any>>();

  useEffect(() => {
    if (verified) {
      if (isSuccessful(verified.status)) {
        dispatch(getMyChargers());
      } else {
        notificationService.sendNotification('error', `Payment error: ${verified.payload.message}`);
      }
      onVerified();
      navigation.navigate(returnToOnboarding ? 'OnboardingStatus' : 'MyChargers');
    }
  }, [verified]);

  return null;
};

export default StripeSubscriptionHandler;